// Navigation translations
export const nav = {
  leistungen: { de: 'Leistungen', en: 'Services' },
  projekte: { de: 'Projekte', en: 'Projects' },
  alleProjekte: { de: 'Alle Projekte', en: 'All Projects' },
  projektmanagement: { de: 'Projektmanagement', en: 'Project Management' },
  kontakt: { de: 'Kontakt', en: 'Contact' },
  projektStarten: { de: 'Projekt starten', en: 'Start Project' },
  alleLeistungen: { de: 'Alle Leistungen auch als Komplettpaket verfügbar', en: 'All services also available as complete package' },
  projektBesprechen: { de: 'Projekt besprechen', en: 'Discuss Project' },
  uebersicht: { de: 'Übersicht', en: 'Overview' },
};

// Service categories
export const services = {
  mobilitaet: {
    label: { de: 'Mobilität', en: 'Mobility' },
    desc: { de: 'Fahrzeugvisualisierung & Transportation Design', en: 'Vehicle visualization & Transportation Design' },
  },
  architektur: {
    label: { de: 'Raum & Architektur', en: 'Space & Architecture' },
    desc: { de: 'Architekturvisualisierung & Raumdesign', en: 'Architectural visualization & Spatial design' },
  },
  kommunikation: {
    label: { de: 'Markenkommunikation', en: 'Brand Communication' },
    desc: { de: 'Visuelle Markenidentität & Kampagnen', en: 'Visual brand identity & Campaigns' },
  },
  design: {
    label: { de: 'Design & Konzeption', en: 'Design & Concept' },
    desc: { de: 'Kreative Konzepte & Designlösungen', en: 'Creative concepts & Design solutions' },
  },
};

// Homepage
export const home = {
  heroTitle: { de: 'Visionen sichtbar machen', en: 'Making Visions Visible' },
  heroSubtitle: { 
    de: 'Wir transformieren Ihre Ideen in außergewöhnliche visuelle Erlebnisse.',
    en: 'We transform your ideas into extraordinary visual experiences.'
  },
  ctaButton: { de: 'Jetzt Projekt starten', en: 'Start Your Project' },
  ctaSecondary: { de: 'Projekte entdecken', en: 'Explore Projects' },
  
  // Services section
  servicesTitle: { de: 'Unsere Leistungen', en: 'Our Services' },
  servicesSubtitle: { 
    de: 'Von der ersten Idee bis zur finalen Umsetzung begleiten wir Sie mit Expertise und Leidenschaft.',
    en: 'From the first idea to final implementation, we accompany you with expertise and passion.'
  },
  
  // Why us section
  whyUsTitle: { de: 'Warum VISUWORKS?', en: 'Why VISUWORKS?' },
  expertise: { de: 'Expertise', en: 'Expertise' },
  expertiseDesc: { 
    de: 'Über 15 Jahre Erfahrung in High-End Visualisierung',
    en: 'Over 15 years of experience in high-end visualization'
  },
  qualitaet: { de: 'Qualität', en: 'Quality' },
  qualitaetDesc: { 
    de: 'Kompromisslose Detailarbeit für perfekte Ergebnisse',
    en: 'Uncompromising attention to detail for perfect results'
  },
  partnerschaft: { de: 'Partnerschaft', en: 'Partnership' },
  partnerschaftDesc: { 
    de: 'Enge Zusammenarbeit für maßgeschneiderte Lösungen',
    en: 'Close collaboration for tailored solutions'
  },
  
  // CTA section
  ctaTitle: { de: 'Bereit für Ihr nächstes Projekt?', en: 'Ready for Your Next Project?' },
  ctaDesc: { 
    de: 'Lassen Sie uns gemeinsam Ihre Vision zum Leben erwecken.',
    en: "Let's bring your vision to life together."
  },
};

// Contact page
export const contact = {
  title: { de: 'Kontakt', en: 'Contact' },
  subtitle: { 
    de: 'Wir freuen uns auf Ihre Nachricht',
    en: 'We look forward to hearing from you'
  },
  formName: { de: 'Name', en: 'Name' },
  formEmail: { de: 'E-Mail', en: 'Email' },
  formPhone: { de: 'Telefon (optional)', en: 'Phone (optional)' },
  formService: { de: 'Gewünschte Leistung', en: 'Desired Service' },
  formServicePlaceholder: { de: 'Bitte wählen', en: 'Please select' },
  formMessage: { de: 'Ihre Nachricht', en: 'Your Message' },
  formSubmit: { de: 'Nachricht senden', en: 'Send Message' },
  formSending: { de: 'Wird gesendet...', en: 'Sending...' },
  formSuccess: { de: 'Vielen Dank! Wir melden uns in Kürze.', en: 'Thank you! We will get back to you shortly.' },
  formError: { de: 'Fehler beim Senden. Bitte versuchen Sie es erneut.', en: 'Error sending. Please try again.' },
  
  // Contact info
  infoTitle: { de: 'Kontaktdaten', en: 'Contact Information' },
  addressTitle: { de: 'Adresse', en: 'Address' },
  phoneTitle: { de: 'Telefon', en: 'Phone' },
  emailTitle: { de: 'E-Mail', en: 'Email' },
};

// Projects page
export const projects = {
  title: { de: 'Projekte', en: 'Projects' },
  subtitle: { 
    de: 'Entdecken Sie unsere ausgewählten Arbeiten',
    en: 'Discover our selected works'
  },
  viewProject: { de: 'Projekt ansehen', en: 'View Project' },
  allProjects: { de: 'Alle Projekte', en: 'All Projects' },
  filterAll: { de: 'Alle', en: 'All' },
  backToProjects: { de: 'Zurück zu Projekte', en: 'Back to Projects' },
};

// Footer
export const footer = {
  description: { 
    de: 'Premium Visualisierungen und Designlösungen für anspruchsvolle Marken.',
    en: 'Premium visualizations and design solutions for discerning brands.'
  },
  leistungen: { de: 'Leistungen', en: 'Services' },
  unternehmen: { de: 'Unternehmen', en: 'Company' },
  rechtliches: { de: 'Rechtliches', en: 'Legal' },
  impressum: { de: 'Impressum', en: 'Imprint' },
  datenschutz: { de: 'Datenschutz', en: 'Privacy Policy' },
  agb: { de: 'AGB', en: 'Terms & Conditions' },
  copyright: { de: 'Alle Rechte vorbehalten.', en: 'All rights reserved.' },
};

// Common
export const common = {
  learnMore: { de: 'Mehr erfahren', en: 'Learn More' },
  readMore: { de: 'Weiterlesen', en: 'Read More' },
  close: { de: 'Schließen', en: 'Close' },
  loading: { de: 'Lädt...', en: 'Loading...' },
  error: { de: 'Ein Fehler ist aufgetreten', en: 'An error occurred' },
  back: { de: 'Zurück', en: 'Back' },
  next: { de: 'Weiter', en: 'Next' },
  previous: { de: 'Zurück', en: 'Previous' },
};

// Service page common elements
export const servicePage = {
  leistungen: { de: 'Leistungen', en: 'Services' },
  prozess: { de: 'Unser Prozess', en: 'Our Process' },
  projekte: { de: 'Ausgewählte Projekte', en: 'Selected Projects' },
  kontaktCta: { de: 'Projekt starten', en: 'Start Project' },
  faq: { de: 'Häufige Fragen', en: 'FAQ' },
};
